import { Col, Form, Input, Modal, Row, Select, useSelect, Icons, Button } from '@pankod/refine-antd'
import { useUpdate, useGetIdentity } from '@pankod/refine-core'
import { useUserContext } from 'context/user'
import { createUserHistory } from 'gql/mutations'
import { ICheckList, IQuestion } from 'interfaces'
const { ExclamationCircleOutlined } = Icons
type MarkRetiredProps = {
  isModalVisible: boolean
  handleOk: any
  handleCancel: any
  id: string
}
export const MarkRetired: React.FC<MarkRetiredProps> = ({ isModalVisible, handleOk, handleCancel, id }) => {
  const [form] = Form.useForm<IQuestion>()
  const { mutate } = useUpdate<IQuestion>()
  const { data: user } = useGetIdentity()
  const { userRole } = useUserContext()
  const { selectProps: checklistSelectProps } = useSelect<ICheckList>({
    resource: 'check_lists',
    queryOptions:{staleTime:Infinity,enabled:isModalVisible},
    fetchSize: 100,
    optionLabel: 'name',
    optionValue: 'id',
    metaData: {
      fields: ['id', 'name'],
    },
    sort: [{ field: 'name', order: 'asc' }],
    onSearch: (value: any) => [
      {
        field: 'name',
        operator: 'contains',
        value: `${value.toLowerCase()}%`,
      },
    ],
  })
  const onFinish = async (values: any) => {

    mutate({
      resource: 'questions',
      id: id,
      values: {
        status: 'Retired',
        mark_retired_reasons: values?.mark_retired_reasons,
        mark_retired_comments: values?.mark_retired_comments,
        updated_by: user?.id,
      },


    },
    )
    createUserHistory('questions', 'mark retired', id, user?.id, userRole)
    form.resetFields()
  }
  return (
    <Modal
      visible={isModalVisible}
      onCancel={handleCancel}
      title={`Mark Retired`}
      footer={[
        <Button key="back" onClick={handleCancel}>
          Cancel
        </Button>,
        <Button key="submit" type="primary" onClick={form.submit}>
          Mark Retired
        </Button>,
      ]}
    >
      <Form form={form} onFinish={(values: any) => onFinish(values).then(() => handleCancel())}>
        <Row gutter={[16, 0]}>
          <Col xs={24} lg={24}>
            <Form.Item label="Reasons" name="mark_retired_reasons" rules={[{ required: true }]}>
              <Select {...checklistSelectProps} mode="multiple" />
            </Form.Item>
          </Col>
          <Col xs={24} lg={824}>
            <Form.Item
              label="Comments"
              name="mark_retired_comments"
              rules={[
                {
                  required: false,
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  )
}
